import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import {
  AvailableCurrencyFragment,
  FinanceFinancialDocumentFilter,
} from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

import { InvoiceFilters } from '../DataTableWrapper/types'

export const currencyFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  availableCurrencies: AvailableCurrencyFragment[],
  currentCurrency?: string[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateCurrencyFilter = (filter?: Filter<string[]>) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ currency: filterValue })
  }

  const currencyOptions = availableCurrencies
    .filter((coreCurrency) => coreCurrency.symbol)
    .map((coreCurrency) => ({
      label: `${coreCurrency.name} (${coreCurrency.isoCode} - ${coreCurrency.symbol})`,
      value: coreCurrency.isoCode,
    }))

  return {
    identifier: 'currency',
    title: i18n.t('finance.invoices.list.fields.currency'),
    path: 'currency',
    onUpdateValue: onUpdateCurrencyFilter,
    default: Boolean(currentCurrency?.length),
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        value: currentCurrency || [],
        options: currencyOptions,
      },
    ],
  }
}
